export default __webpack_public_path__ + "static/media/scissors.54562967.svg";